import { schedulesEntryPoint } from '@jira/spa-apps__servicedesk-schedules/src/schedulesEntryPoint.entrypoint.tsx';
import { schedulesRoute } from '@jira/router-routes__servicedesk-schedules-routes/src/schedulesRoute.tsx';
import { PageSkeleton } from '@jira/spa-apps__servicedesk-schedules/src/PageSkeleton.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { currentUserResource } from '@jira/router-resources__current-user/src/useCurrentUserResource.tsx';
import { routingOnboardingFinishedResource } from '@jira/router-resources__service-desk-routing/src/routingSetupStatusResource.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const entryPoint = createPageEntryPoint({ main: schedulesEntryPoint });

export const schedulesRouteEntry: Route = createEntry(schedulesRoute, () => ({
	group: 'servicedesk',
	// eslint-disable-next-line no-restricted-syntax
	component: ErrorPagesNotFound,
	layout: serviceProjectLayout,
	skeleton: PageSkeleton,
	ufoName: 'jsm-schedules',

	navigation: {
		menuId: MenuIdProjects,
	},

	forPaint: [LazyAtlassianNavigation],

	resources: [
		routingOnboardingFinishedResource,
		...getServiceDeskNavigationResources(),
		...getServicedeskPageContextResources(),
		getConsolidationStateResource(),
		currentUserResource,
	],

	entryPoint: () => {
		if (
			!isFeatureEnabled('jira-service-management', 'jsm-workforce') ||
			!fg('jsm_workforce_optimization_main')
		) {
			return undefined;
		}
		return entryPoint;
	},

	supportsPreviewPanel: true,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
